// Module
var code = "<a class=\"btn yellow subFormControl\" data-bind=\"style: _style\"> <i class=\"fa fa-lock\"></i> <!-- ko text: _labels.RESET_SECURITY --><!-- /ko --> </a> ";
// Exports
export default code;